import { render, staticRenderFns } from "./remote-phone-modify.vue?vue&type=template&id=c7ae1a3e&scoped=true"
import script from "./remote-phone-modify.vue?vue&type=script&lang=ts"
export * from "./remote-phone-modify.vue?vue&type=script&lang=ts"
import style0 from "./remote-phone-modify.vue?vue&type=style&index=0&id=c7ae1a3e&prod&lang=less&scoped=true"
import style1 from "./remote-phone-modify.vue?vue&type=style&index=1&id=c7ae1a3e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ae1a3e",
  null
  
)

export default component.exports